const insuranceCatalog = [
  {
    title: "Car Insurance",
    type: "car",
    accent: "from-peach to-coral",
    shortLabel: "Car",
    description:
      "Comprehensive protection for private cars with add-ons for zero depreciation, roadside help, and cashless repairs.",
  },
  {
    title: "Bike Insurance",
    type: "bike",
    accent: "from-sky to-cyan-400",
    shortLabel: "Bike",
    description:
      "Two-wheeler cover built for fast renewals, theft protection, accident support, and affordable annual premiums.",
  },
  {
    title: "Commercial Insurance",
    type: "commercial",
    accent: "from-amber to-orange-300",
    shortLabel: "Commercial",
    description:
      "Business-ready cover for shops, fleets, offices, and liability risks with flexible policy combinations.",
  },
  {
    title: "Health Insurance",
    type: "health",
    accent: "from-mint to-emerald-400",
    shortLabel: "Health",
    description:
      "Cashless hospitalization, family floater options, preventive care benefits, and top-up protection for rising medical costs.",
  },
  {
    title: "Life Insurance",
    type: "life",
    accent: "from-rose-400 to-peach",
    shortLabel: "Life",
    description:
      "Long-term financial security for your family with savings-linked and protection-focused life plans.",
  },
  {
    title: "Term Insurance",
    type: "term",
    accent: "from-indigo-400 to-sky",
    shortLabel: "Term",
    description:
      "High coverage at lower premiums, designed to protect income, liabilities, and long-term family goals.",
  },
];

const buyNowHighlights = [
  "Life insurance for family security and legacy planning",
  "Health insurance for medical protection and cashless care",
  "Car and bike insurance for everyday road confidence",
  "Commercial coverage for business assets and liability needs",
];

window.AppData = window.AppData || {};
window.AppData.buyNowContent = {
  buyNowHighlights,
  insuranceCatalog,
};
